import React, { useEffect, useState, useRef } from 'react';
import '../App.css'; // Optional: for custom styling
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

const Dropdown = ({
  options,
  returnSelectedOption,

  keys = [],
  returnSelectedKey,
  placeholder
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState( null);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionClick = (option) => {
    const index = options.indexOf(option);
    setSelectedOption(option);

    if (typeof returnSelectedOption === "function") {
      returnSelectedOption(option);
    }

    if (typeof returnSelectedKey === "function" && index !== -1) {
      returnSelectedKey(keys[index]);
    }

    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Reset selected option if options change and current option is no longer valid
useEffect(() => {
  // if current selected option is not valid anymore, reset
  if (selectedOption && !options.includes(selectedOption)) {
    setSelectedOption(null);
    return;
  }

  // if there's no selectedOption and no placeholder, pick the first option
  if (!selectedOption && !placeholder && options.length > 0) {
    setSelectedOption(options[0]);

    // trigger returnSelectedOption (and key) here too
    if (typeof returnSelectedOption === "function") {
      returnSelectedOption(options[0]);
    }

    if (typeof returnSelectedKey === "function" && keys.length > 0) {
      returnSelectedKey(keys[0]);
    }
  }
}, [options, placeholder]);


  return (
    <div className="custom-dropdown" ref={dropdownRef}>
      <div className="dropdown-header" onClick={toggleDropdown}>
        {selectedOption || placeholder || options[0]}
        <FontAwesomeIcon icon={faChevronDown} style={{ marginLeft: "5px" }} />
      </div>
      {isOpen && (
        <ul className="dropdown-list">
          {options.map((option, index) => (
            <li key={index} onClick={() => handleOptionClick(option)}>
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Dropdown;

